<template>
<div>
 <div id="popupForget1" class="popup_Show" @click="closePopup"> </div>

    <form @submit.prevent="submitform">
      <div class="popupForget">
        <div style="text-align: center">
          <svg fill="#000000" height="50px" width="50px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g id="Change_password">
                <path
                  d="M464.4326,147.54a9.8985,9.8985,0,0,0-17.56,9.1406,214.2638,214.2638,0,0,1-38.7686,251.42c-83.8564,83.8476-220.3154,83.874-304.207-.0088a9.8957,9.8957,0,0,0-16.8926,7.0049v56.9a9.8965,9.8965,0,0,0,19.793,0v-34.55A234.9509,234.9509,0,0,0,464.4326,147.54Z">
                </path>
                <path
                  d="M103.8965,103.9022c83.8828-83.874,220.3418-83.8652,304.207-.0088a9.8906,9.8906,0,0,0,16.8926-6.9961v-56.9a9.8965,9.8965,0,0,0-19.793,0v34.55C313.0234-1.3556,176.0547,3.7509,89.9043,89.9012A233.9561,233.9561,0,0,0,47.5674,364.454a9.8985,9.8985,0,0,0,17.56-9.1406A214.2485,214.2485,0,0,1,103.8965,103.9022Z">
                </path>
                <path
                  d="M126.4009,254.5555v109.44a27.08,27.08,0,0,0,27,27H358.5991a27.077,27.077,0,0,0,27-27v-109.44a27.0777,27.0777,0,0,0-27-27H153.4009A27.0805,27.0805,0,0,0,126.4009,254.5555ZM328,288.13a21.1465,21.1465,0,1,1-21.1465,21.1464A21.1667,21.1667,0,0,1,328,288.13Zm-72,0a21.1465,21.1465,0,1,1-21.1465,21.1464A21.1667,21.1667,0,0,1,256,288.13Zm-72,0a21.1465,21.1465,0,1,1-21.1465,21.1464A21.1667,21.1667,0,0,1,184,288.13Z">
                </path>
                <path
                  d="M343.6533,207.756V171.7538a87.6533,87.6533,0,0,0-175.3066,0V207.756H188.14V171.7538a67.86,67.86,0,0,1,135.7208,0V207.756Z">
                </path>
              </g>
            </g>
          </svg>
        </div>
        <h2>Forget Password</h2>
        <p style="font-size: 13px; position: relative; top: 9px;">Click "Forgot Password," enter your email, follow the
          reset link, create a new password, and log in.</p>

        <div class="fieldChangePass">
          <label class="form_LabelChangePass" for=""></label>
          <input v-model="email" type="text" placeholder="Enter your email address here !" class="textboxlChangePass"
            required />
        </div>
        <br />
        <br />
        <div class="createRoom_Btn_Container">
          <button class="CreateRoom" :disabled="buttonDisabled">
            <svg fill="#ffff" width="14px" height="14px" style="position: relative;
    left: -3px;
    top: 2px;" viewBox="0 0 16 16" id="request-sent-16px" xmlns="http://www.w3.org/2000/svg" stroke="#ffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path id="Path_50" data-name="Path 50"
                  d="M-11.5,0h-11A2.5,2.5,0,0,0-25,2.5v8A2.5,2.5,0,0,0-22.5,13h.5v2.5a.5.5,0,0,0,.309.462A.489.489,0,0,0-21.5,16a.5.5,0,0,0,.354-.146L-18.293,13H-11.5A2.5,2.5,0,0,0-9,10.5v-8A2.5,2.5,0,0,0-11.5,0ZM-10,10.5A1.5,1.5,0,0,1-11.5,12h-7a.5.5,0,0,0-.354.146L-21,14.293V12.5a.5.5,0,0,0-.5-.5h-1A1.5,1.5,0,0,1-24,10.5v-8A1.5,1.5,0,0,1-22.5,1h11A1.5,1.5,0,0,1-10,2.5Zm-2.038-3.809a.518.518,0,0,1-.109.163l-2,2A.5.5,0,0,1-14.5,9a.5.5,0,0,1-.354-.146.5.5,0,0,1,0-.708L-13.707,7H-18.5A1.5,1.5,0,0,0-20,8.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5A2.5,2.5,0,0,1-18.5,6h4.793l-1.147-1.146a.5.5,0,0,1,0-.708.5.5,0,0,1,.708,0l2,2a.518.518,0,0,1,.109.163A.505.505,0,0,1-12.038,6.691Z"
                  transform="translate(25)"></path>
              </g>
            </svg>Change Password Request</button>
        </div>
        <p class="timer" v-if="showTimer" style="color: red; font-size: 14px; margin: 42px 0px">Your password reset link
          has been sent to your registered email address. You can request another reset link after {{ minutes }} minutes
          and {{ seconds }} seconds</p>
      </div>
    </form>

</div>
    

</template>
<script>
import axios from "axios";
import { useToast } from 'vue-toastification';

import notificationService from "@/notification/services/notificationService";

export default {
  name: "forgotPassword",

  data() {
    return {
      email: "",
      // showPopupForget1: true,
      buttonDisabled: false,
      showTimer: false,
      minutes: 0,
      seconds: 0,
      disabledEmail: "",
      disabledTimestamp: 0,
    };
  },
  mounted() {
    // Retrieve the email and timer state from localStorage when the component is mounted
    const storedEmail = localStorage.getItem("disabledEmail");
    if (storedEmail) {
      this.disabledEmail = storedEmail;
      this.disabledTimestamp = parseInt(localStorage.getItem("disabledTimestamp"));
      if (this.isWithin10Minutes()) {
        this.buttonDisabled = true;
        this.showTimer = true;
        this.startTimer();
      } else {
        this.resetDisabledState();
      }
    }
  },
  methods: {
    // Create a toast instance

    async submitform() {
      if (!this.email) {
        toast.error("Please enter an email.");
        return;
      }
      const toast = useToast();
      try {
        const { deviceInfo, deviceLocation } = await notificationService.getDeviceInfoAndLocation()
        const response = await axios.post(process.env.VUE_APP_BASE_URL + "auth/forgotpassword", {
          email: this.email,
          deviceInfo: deviceInfo,
          deviceLocation: deviceLocation
        });

        if (response.status === 200) {
          if (this.disabledEmail === this.email && this.isWithin10Minutes()) {
            // Button is already disabled for this email within 10 minutes, do nothing
            return;
          }

          // alert("Reset password link sent. Check your email.");
          toast.success('Reset password link has been sent to your mail. Please check your mail', {
            timeout: 3000,
            toastClassName: "resetLink_success",
          }
          );
          console.log(response);

          this.buttonDisabled = true; // Disable the button
          this.disabledEmail = this.email; // Store the email for which button is disabled
          this.disabledTimestamp = Date.now(); // Store the current timestamp

          let countdown = 300; // 5 minutes in seconds
          this.showTimer = true;

          const timerInterval = setInterval(() => {
            if (countdown <= 0) {
              clearInterval(timerInterval);
              this.buttonDisabled = false; // Enable the button after 10 minutes
              this.showTimer = false;
              this.resetDisabledState();
            } else {
              this.minutes = Math.floor(countdown / 60);
              this.seconds = countdown % 60;
              countdown--;
            }
          }, 1000);
        }
      } catch (response) {
        // console.error('Error', error);

        // alert(response.response.data);
        toast.success(response.response.data
        );
      }
    },
    resetDisabledState() {
      this.disabledEmail = "";
      this.disabledTimestamp = 0;
    },
    isWithin10Minutes() {
      return Date.now() - this.disabledTimestamp < 10 * 60 * 500; // Check if less than 10 minutes
    },
    reset() {
      this.email = "";
    },

    closePopup() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
@import url(./Login.css);
</style>
